import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { KmpmasterService } from 'src/app/services/kmpmaster.service';
declare var $: any;
declare var jQuery: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-kmpauthoriserectify-component',
  templateUrl: './kmpauthoriserectify-component.component.html',
  styleUrls: ['./kmpauthoriserectify-component.component.css']
})
export class KmpauthoriserectifyComponentComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptions: DataTables.Settings = {};
  dtOptionsOfUnauthorizekmpship: DataTables.Settings = {};
  dtOptionsOfUnauthorizeSubkmp: DataTables.Settings = {};
  dtOptionsOfUnerectifiedKmpship: DataTables.Settings = {};
  dtOptionsOfUnrectifiedSubkmp: DataTables.Settings = {};
  dtTriggerUnauthorizekmpship: Subject<any> = new Subject();
  dtTriggerUnauthorizeSubkmp: Subject<any> = new Subject();
  dtTriggerUnerectifiedKmpship: Subject<any> = new Subject();
  dtTriggerUnrectifiedSubkmp: Subject<any> = new Subject();
  dtTrigger: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  unauthorizeSubkmpList: any[];
  unauthorizeKmpshipsList: any[];
  unRectifiedKmpshipsList: any[];
  unRectifiedSubkmpList: any[];
  Isselected: boolean;
  checkIsslected: boolean;
  authorizeArray: any;
  subauthorizeArray: any;
  rectifyeArray: any;
  subrectifyArray: any;
  DinNumber: String;
  FirstName: String;
  MiddleName: String;
  LastName: String;
  FatherFirstName: String;
  FatherMiddleName: String;
  FatherLastName: String;
  MotherFirstName: String;
  MotherMiddleName: String;
  MotherLastName: String;
  Nationality: String;
  BirthDate: any;
  SpouseFirstName: String;
  SpouseMiddleName: String;
  SpouseLastName: String;
  Occupation: String;
  AppointmentDate: any;
  ReAppointmentDate: any;
  CessationReason: String;
  CessationDate: any;
  BoardResolutionDate: any;
  Pincode: String;
  Line1: String;
  Line2: String;
  Country: String;
  State: String;
  City: String;
  present: String;
  Permanent: String;
  pLine1: String;
  pLine2: String;
  pCity: String;
  pState: String;
  pCountry: String;
  pPincode: String;
  hidekmpshipauthtable: any;
  hidesubkmpauthtable: any;
  hidekmpshiprectify: any;
  hidesubkmprectify: any;
  hideauthorizebutton: any;
  hiderectifybutton: any;
  selectedAll: any;
  allSelected: any;
  allsubkmpselected: any;
  selectedAllKmpship: any;
  allsubdirectorselected: any;
  CompanyName: any;
  CIN: any;
  registerOfficeAddress: any;
  password: any;
  authenticationOrRectify: any;
  constructor(private directorMasterService: DirectorMasterService, private alert: AlertComponent, 
    private KmpMasterService: KmpmasterService, private router: Router, private loginService: LoginService, 
    private activatedRoute: ActivatedRoute,private commonFunction: CommonFunction) { }

  ngOnInit() {

    this.environmentSettings = environment;

    this.Isselected = false;
    this.checkIsslected = false;
    this.authorizeArray = [];
    this.unauthorizeSubkmpList = [];
    this.unauthorizeKmpshipsList = [];
    this.unRectifiedKmpshipsList = [];
    this.unRectifiedSubkmpList = [];
    this.dtOptionsOfUnauthorizekmpship = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };
    this.dtOptionsOfUnerectifiedKmpship = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };
    this.dtOptionsOfUnauthorizeSubkmp = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };
    this.dtOptionsOfUnrectifiedSubkmp = {
      destroy: true,
      scrollY: "260px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }]
    };
    var companyData = JSON.parse(localStorage.getItem("companyDetails"));
    this.directorMasterService.getCompanyDetails(companyData.companyID)
      .subscribe((getData:any) => {
        var companyInformation = getData.CompanyDetails[0];
        this.CompanyName = companyInformation.CompanyName.value;
        this.CIN = companyInformation.RegistrationNumber.value;
        this.registerOfficeAddress = companyInformation.RegisteredOfficeAddress.value;
      });

    this.activatedRoute.params.subscribe(params => {
      console.log(params['kmpId']);
      if (params['kmpId'] != undefined) {
        localStorage.setItem('KmpId', params['kmpId']);
        if (params['authrectify'] != undefined && params['authrectify'] == "authenticate") {
          this.authenticationOrRectify = "authenticate";
          this.getUnauthorizeKmpshipsSubkmp(params['kmpId']);
        }
        else if (params['authrectify'] != undefined && params['authrectify'] == "rectify") {
          this.authenticationOrRectify = "rectify";
          this.getUnRectifiedKmpshipsSubkmp(params['kmpId']);
        }
      }
    });
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getUnauthorizeKmpshipsSubkmp(kmpId) {
     
    this.hidekmpshipauthtable = false;
    this.hidesubkmpauthtable = false;
    this.hidekmpshiprectify = true;
    this.hidesubkmprectify = true;
    this.hideauthorizebutton = false;
    this.hiderectifybutton = true;
    this.unauthorizeSubkmpList = [];
    this.unauthorizeKmpshipsList = [];
    this.KmpMasterService.getUnauthorizeKmpshipSubKmp(kmpId)
      .subscribe((unauthorizekmpshipList:any) => {
         
        let dt;
        if (unauthorizekmpshipList.status == 0) {
          if (unauthorizekmpshipList.unauthorizeDataList.length > 0) {
            var table = $('#authorizekmpshiptable').DataTable({ destroy: true });
            table.destroy();
            this.unauthorizeKmpshipsList = unauthorizekmpshipList.unauthorizeDataList[0].KmpshipData;
            this.dtTriggerUnauthorizekmpship.next();
            var table = $('#authorizeSubkmptable').DataTable({ destroy: true });
            table.destroy();
            this.unauthorizeSubkmpList = unauthorizekmpshipList.unauthorizeDataList[0].SubKmpData;
            this.dtTriggerUnauthorizeSubkmp.next();
            this.DinNumber = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.Din;
            this.FirstName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.FirstName;
            this.MiddleName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.MiddleName;
            this.LastName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.LastName;
            this.FatherFirstName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.FatherFirstName;
            this.FatherMiddleName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.FatherMiddleName;
            this.FatherLastName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.FatherLastName;
            this.MotherFirstName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.MotherFirstName;
            this.MotherMiddleName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.MotherMiddleName;
            this.MotherLastName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.MotherLastName;
            this.Nationality = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.Nationality;
            dt = this.setFormatDate(unauthorizekmpshipList.unauthorizeDataList[0].KmpData.DateOfBirth)
            if (dt != null) {
              this.BirthDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BirthDate = this.BirthDate.day + "-" + this.BirthDate.month + "-" + this.BirthDate.year;
            }
            else {
              this.BirthDate = '';
            }
            this.SpouseFirstName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.SpouseFirstName;
            this.SpouseMiddleName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.SpouseMiddleName;
            this.SpouseLastName = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.SpouseLastName;
            this.Occupation = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.Occupation;
            dt = new Date(this.setFormatDate(unauthorizekmpshipList.unauthorizeDataList[0].KmpData.AppointmentDate));
            if (dt != null) {
              this.AppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.AppointmentDate = this.AppointmentDate.day + "-" + this.AppointmentDate.month + "-" + this.AppointmentDate.year;
            }
            else {
              this.AppointmentDate = '';
            }
            dt = this.setFormatDate(unauthorizekmpshipList.unauthorizeDataList[0].KmpData.ReAppointmentDate);
            if (dt != null) {
              this.ReAppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.ReAppointmentDate = this.ReAppointmentDate.day + "-" + this.ReAppointmentDate.month + "-" + this.ReAppointmentDate.year;
            }
            else {
              this.ReAppointmentDate = '';
            }
            this.CessationReason = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.CessationReason;
            dt = this.setFormatDate(unauthorizekmpshipList.unauthorizeDataList[0].KmpData.CessationDate);
            if (dt != null) {
              this.CessationDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.CessationDate = this.CessationDate.day + "-" + this.CessationDate.month + "-" + this.CessationDate.year;
            }
            dt = this.setFormatDate(unauthorizekmpshipList.unauthorizeDataList[0].KmpData.BoardResolutionDate);
            if (dt != null) {
              this.BoardResolutionDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BoardResolutionDate = this.BoardResolutionDate.day + "-" + this.BoardResolutionDate.month + "-" + this.BoardResolutionDate.year;
            }
            else {
              this.BoardResolutionDate = '';
            }
            this.Line1 = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PresentResidentialAddress.Line1;
            this.Line2 = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PresentResidentialAddress.Line2;
            this.Country = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PresentResidentialAddress.Country;
            this.State = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PresentResidentialAddress.State;
            this.City = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PresentResidentialAddress.City;
            this.Pincode = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PresentResidentialAddress.PinCode;
            this.present = this.Line1 + "," + this.Line2 + "," + this.City + "," + this.State + "," + this.Country + "," + this.Pincode;
            this.pLine1 = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PermenantResidentialAddress.Line1;
            this.pLine2 = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PermenantResidentialAddress.Line2;
            this.pCountry = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PermenantResidentialAddress.Country;
            this.pState = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PermenantResidentialAddress.State;
            this.pCity = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PermenantResidentialAddress.City;
            this.pPincode = unauthorizekmpshipList.unauthorizeDataList[0].KmpData.PermenantResidentialAddress.PinCode;
            this.Permanent = this.pLine1 + "," + this.pLine2 + "," + this.pState + "," + this.pCity + "," + this.pPincode;
          }
        }
        else {
          this.unauthorizeKmpshipsList = [];
          this.unauthorizeSubkmpList = [];
        }
      });
  }

  getUnRectifiedKmpshipsSubkmp(kmpId) {
     
    this.hidekmpshipauthtable = true;
    this.hidesubkmpauthtable = true;
    this.hidekmpshiprectify = false;
    this.hidesubkmprectify = false;
    this.hideauthorizebutton = true;
    this.hiderectifybutton = false;
    let dt;
    this.unRectifiedKmpshipsList = [];
    this.unRectifiedSubkmpList = [];
    this.KmpMasterService.getUnRectifiedKmpshipSubkmp(kmpId)
      .subscribe((unRectifiedkmpshipList:any) => {
         
        if (unRectifiedkmpshipList.status == 0) {
          if (unRectifiedkmpshipList.unrectifiedDataList.length > 0) {
            var table = $('#rectifykmptable').DataTable({ destroy: true });
            table.destroy();
            this.unRectifiedKmpshipsList = unRectifiedkmpshipList.unrectifiedDataList[0].KmpshipData;
            this.dtTriggerUnerectifiedKmpship.next();
            var table = $('#rectifySubkmptable').DataTable({ destroy: true });
            table.destroy();
            this.unRectifiedSubkmpList = unRectifiedkmpshipList.unrectifiedDataList[0].SubKmpData;
            this.dtTriggerUnrectifiedSubkmp.next();
            this.DinNumber = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.Din;
            this.FirstName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.FirstName;
            this.MiddleName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.MiddleName;
            this.LastName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.LastName;
            this.FatherFirstName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.FatherFirstName;
            this.FatherMiddleName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.FatherMiddleName;
            this.FatherLastName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.FatherLastName;
            this.MotherFirstName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.MotherFirstName;
            this.MotherMiddleName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.MotherMiddleName;
            this.MotherLastName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.MotherLastName;
            this.Nationality = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.Nationality;
            dt = this.setFormatDate(unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.DateOfBirth);
            if (dt != null) {
              this.BirthDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BirthDate = this.BirthDate.day + "-" + this.BirthDate.month + "-" + this.BirthDate.year;
            }
            this.SpouseFirstName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.SpouseFirstName;
            this.SpouseMiddleName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.SpouseMiddleName;
            this.SpouseLastName = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.SpouseLastName;
            this.Occupation = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.Occupation;
            dt = new Date(this.setFormatDate(unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.AppointmentDate));
            if (dt != null) {
              this.AppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.AppointmentDate = this.AppointmentDate.day + "-" + this.AppointmentDate.month + "-" + this.AppointmentDate.year;
            }
            else {
              this.AppointmentDate = '';
            }
            dt = this.setFormatDate(unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.ReAppointmentDate);
            if (dt != null) {
              this.ReAppointmentDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.ReAppointmentDate = this.ReAppointmentDate.day + "-" + this.ReAppointmentDate.month + "-" + this.ReAppointmentDate.year;
            }
            else {
              this.ReAppointmentDate = '';
            }
            this.CessationReason = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.CessationReason;
            dt = this.setFormatDate(unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.CessationDate);
            if (dt != null) {
              this.CessationDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.CessationDate = this.CessationDate.day + "-" + this.CessationDate.month + "-" + this.CessationDate.year;
            }
            else {
              this.CessationDate = '';
            }
            dt = this.setFormatDate(unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.BoardResolutionDate);
            if (dt != null) {
              this.BoardResolutionDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              this.BoardResolutionDate = this.BoardResolutionDate.day + "-" + this.BoardResolutionDate.month + "-" + this.BoardResolutionDate.year;
            }
            else {
              this.BoardResolutionDate = '';
            }
            this.Line1 = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PresentResidentialAddress.Line1;
            this.Line2 = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PresentResidentialAddress.Line2;
            this.Country = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PresentResidentialAddress.Country;
            this.State = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PresentResidentialAddress.State;
            this.City = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PresentResidentialAddress.City;
            this.Pincode = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PresentResidentialAddress.PinCode;
            this.present = this.Line1 + "," + this.Line2 + "," + this.City + "," + this.State + "," + this.Country + "," + this.Pincode;
            this.pLine1 = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PermenantResidentialAddress.Line1;
            this.pLine2 = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PermenantResidentialAddress.Line2;
            this.pCountry = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PermenantResidentialAddress.Country;
            this.pState = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PermenantResidentialAddress.State;
            this.pCity = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PermenantResidentialAddress.City;
            this.pPincode = unRectifiedkmpshipList.unrectifiedDataList[0].KmpData.PermenantResidentialAddress.PinCode;
            this.Permanent = this.pLine1 + "," + this.pLine2 + "," + this.pState + "," + this.pCity + "," + this.pPincode;
          }
        }
        else {
          this.unRectifiedKmpshipsList = [];
          this.unRectifiedSubkmpList = [];
        }
      });
  }



  selectAll() {
    for (var i = 0; i < this.unauthorizeKmpshipsList.length; i++) {
      this.unauthorizeKmpshipsList[i].SelectedKmpship = this.selectedAll;
      this.Isselected = this.selectedAll;
    }
  }

  checkselected(ev) {
    if (ev.target.checked == true) {
      this.Isselected = true;
    }
    else {
      this.Isselected = false;
    }
  }

  checkIfAllSelected() {
    this.selectedAll = this.unauthorizeKmpshipsList.every(function (item: any) {
      return item.SelectedKmpship == true;
    })
  }

  allSelect() {
    for (var i = 0; i < this.unauthorizeSubkmpList.length; i++) {
      this.unauthorizeSubkmpList[i].SelectedSubkmp = this.allSelected;
      this.Isselected = this.allSelected;
    }
  }

  checkrectifyselected(ev) {
    if (ev.target.checked == true) {
      this.checkIsslected = true;
    }
    else {
      this.checkIsslected = false;
    }
  }

  checksubIfAllSelected() {
    this.allSelected = this.unauthorizeSubkmpList.every(function (item: any) {
      return item.SelectedSubkmp == true;
    })
  }

  selectAllKmpshipToRectify() {
    for (var i = 0; i < this.unRectifiedKmpshipsList.length; i++) {
      this.unRectifiedKmpshipsList[i].SelectedKmpship = this.selectedAllKmpship;
      this.checkIsslected = this.selectedAllKmpship;
    }
  }

  checkIfAllKmpshipSelected() {
    this.selectedAllKmpship = this.unRectifiedKmpshipsList.every(function (item: any) {
      return item.SelectedKmpship == true;
    })
  }

  allSubkmpSelect() {
    for (var i = 0; i < this.unRectifiedSubkmpList.length; i++) {
      this.unRectifiedSubkmpList[i].SelectedSubkmp = this.allsubkmpselected;
      this.checkIsslected = this.allsubkmpselected;
    }
  }

  checksubrectifyIfAllSelected() {
    this.allsubkmpselected = this.unRectifiedSubkmpList.every(function (item: any) {
      return item.SelectedSubkmp == true;
    })
  }

  authorize() {
     
    var authorizedKMPCompanyName = '', authorizedSubKMPCompanyName = '';
    this.authorizeArray = [];
    this.subauthorizeArray = [];
    for (let unauthorizeKMP of this.unauthorizeKmpshipsList) {
      if (unauthorizeKMP.SelectedKmpship === true) {
        authorizedKMPCompanyName = authorizedKMPCompanyName + ',' + unauthorizeKMP.OfficeName;
        this.authorizeArray.push(unauthorizeKMP);
      }
    }

    if (authorizedKMPCompanyName != '') {
      if (authorizedKMPCompanyName.substr(0, 1) == ',') {
        authorizedSubKMPCompanyName = authorizedKMPCompanyName.substr(1);
        authorizedSubKMPCompanyName = authorizedKMPCompanyName;
      }
    }

    for (let unauthorizeSubKMP of this.unauthorizeSubkmpList) {
      if (unauthorizeSubKMP.SelectedSubkmp === true) {
        authorizedSubKMPCompanyName = authorizedSubKMPCompanyName + ',' + unauthorizeSubKMP.CompanyName;
        this.subauthorizeArray.push(unauthorizeSubKMP);
      }
    }

    if (authorizedSubKMPCompanyName != '') {
      if (authorizedSubKMPCompanyName.substr(0, 1) == ',') {
        authorizedSubKMPCompanyName = authorizedSubKMPCompanyName.substr(1);
      }
    }

    var authorizedata = {
      "kmpship": this.authorizeArray,
      "subkmp": this.subauthorizeArray
    }
    // console.log('authorizedata',authorizedata)
    this.KmpMasterService.authorize(authorizedata)
      .subscribe((kmpship:any) => {
        if (kmpship.status == 0) {
           
          // this.router.navigate(['/KMP']);
           
          var table = $('#authorizekmpshiptable').DataTable({ destroy: true });
          table.destroy();
          var table = $('#authorizeSubkmptable').DataTable({ destroy: true });
          table.destroy();
          this.Isselected = false;//disable authorize button
          this.selectedAll = false;//uncheck all authorize director
          this.allSelected = false;//unchecheck all authorize sub director
          this.getUnauthorizeKmpshipsSubkmp(localStorage.getItem('KmpId'));
          this.alert.success(authorizedSubKMPCompanyName + ' Company is authorized successfully.');
          this.password = null;
          return true;
        }
        else {
          this.alert.error(kmpship.message);
        }
      });
  }

  rectify() {
     
    var rectifiedKmpCompanyName = '', rectifiedSubKmpCompanyName = '';
    this.rectifyeArray = [];
    this.subrectifyArray = [];
    for (let unRectifiedKMP of this.unRectifiedKmpshipsList) {
      if (unRectifiedKMP.SelectedKmpship === true) {
        rectifiedKmpCompanyName = rectifiedKmpCompanyName + ',' + unRectifiedKMP.OfficeName;
        this.rectifyeArray.push(unRectifiedKMP);
      }
    }

    if (rectifiedKmpCompanyName != '') {
      if (rectifiedKmpCompanyName.substr(0, 1) == ',') {
        rectifiedKmpCompanyName = rectifiedKmpCompanyName.substr(1);
        rectifiedSubKmpCompanyName = rectifiedKmpCompanyName;
      }
    }

    for (let unRectifiedSubKMP of this.unRectifiedSubkmpList) {
      if (unRectifiedSubKMP.SelectedSubkmp === true) {
        rectifiedSubKmpCompanyName = rectifiedSubKmpCompanyName + ',' + unRectifiedSubKMP.CompanyName;
        this.subrectifyArray.push(unRectifiedSubKMP);
      }
    }

    if (rectifiedSubKmpCompanyName != '') {
      if (rectifiedSubKmpCompanyName.substr(0, 1) == ',') {
        rectifiedSubKmpCompanyName = rectifiedSubKmpCompanyName.substr(1);
      }
    }
  

    var rectifydata = {
  "kmpship": this.rectifyeArray,
  "subkmp": this.subrectifyArray
}
// console.log('rectifydata',rectifydata);

this.KmpMasterService.rectify(rectifydata)
  .subscribe((kmpship:any) => {
    if (kmpship.status == 0) {
       
      // this.router.navigate(['/KMP']);
       
          var table = $('#rectifykmptable').DataTable({ destroy: true });
          table.destroy();
          var table = $('#rectifySubkmptable').DataTable({ destroy: true });
          table.destroy();
          this.checkIsslected = false;//disable rectify button
          this.selectedAllKmpship = false;//uncheck all authorize director
          this.allsubkmpselected = false;//uncheck all rectify subdirector
          this.password = null;
          this.getUnRectifiedKmpshipsSubkmp(localStorage.getItem('KmpId'));
          this.alert.success(rectifiedSubKmpCompanyName + ' Company is rectified successfully.');
          return true;
    }
    else {
      this.alert.error('Record rectification is failed.');
      this.password = null;
      return false;
    }
  });
  }



Confirmation() {
  $('#confirmation').modal('toggle');
}

checkPassword() {
  
  if (this.password == null) {
    this.alert.error('Please enter password.');
    return false;
  }
  var user = JSON.parse(localStorage.getItem("user"));
  var decrEmailId=this.commonFunction.decrypt(user.EmailId);

  let loginModel = {
    // "UserName": user.EmailId,
    "UserName": decrEmailId,
    "Password": this.password,
    "CompanyId": user.CompanyId
  };
// console.log('loginModel',loginModel);
  this.loginService.login(loginModel)
    .subscribe(data => {
      console.log('data',data);
      if (data.status == 0) {
        if (this.authenticationOrRectify == "authenticate") {
          this.authorize();
        }
        else if (this.authenticationOrRectify == "rectify") {
          this.rectify();
        }
      }
      else {
        // alert('Please enter correct password');
        this.alert.error('Password is incorrect.');
        this.password = null;
        return false;
      }
    })
}

registerKmp() {
  this.router.navigate(['/KMP']);
}

}
